import type { RowRef } from "../../models/DriverInputRow.model";
import { getVoyagePrefix, clearLocalStorageByPrefix } from "./StorageKeys";
import { clearVoyageDriversStore } from "./Store";
import type { MutableRefObject, RefObject, Dispatch, SetStateAction } from "react";

export function resetVoyageState(opts: {
  tcCode?: string;
  voyageNo?: string;
  rowRefs: MutableRefObject<(RowRef | null)[]>;
  commentResetRefs: MutableRefObject<Record<string, () => void>>;
  formRef: RefObject<HTMLFormElement>;
  setVoyagePnlData: Dispatch<SetStateAction<any>>;
  setDriversSequence: Dispatch<SetStateAction<string[]>>;
  unallocTimerRef: MutableRefObject<number | null>;
  after?: () => void; // optional callback
}) {
  const {
    tcCode,
    voyageNo,
    rowRefs,
    commentResetRefs,
    formRef,
    setVoyagePnlData,
    setDriversSequence,
    unallocTimerRef,
    after,
  } = opts;

  rowRefs.current?.forEach((ref) => ref?.resetRowValues?.());
  Object.values(commentResetRefs.current).forEach((reset) => reset());

  // Remove voyage draft storage so backend data can hydrate cleanly on the next open.
  clearVoyageDriversStore(tcCode, voyageNo);
  const voyagePrefix = getVoyagePrefix(tcCode, voyageNo);
  clearLocalStorageByPrefix(voyagePrefix);

  setVoyagePnlData((prev: any) => (prev ? { ...prev, addDrivers: [] } : prev));
  setDriversSequence([]);

  if (unallocTimerRef.current !== null) {
    window.clearTimeout(unallocTimerRef.current);
    unallocTimerRef.current = null;
  }

  formRef.current?.reset?.();
  after?.();
}
